import React, { useState, useEffect, useRef } from 'react'
import {
  List,
  Datagrid,
  TextField,
  useTranslate,
  useListContext,
  useNotify,
  useGetIdentity,
  BooleanField,
} from 'react-admin'
import { Container } from '@mui/material'
import { CardCommon } from 'src/components/uiElements'
import { ListViewActionsButtons } from 'src/components/uiElements/buttons/ListViewActionsButtons'
import { ListViewTopToolbar } from 'src/components/uiElements/CRUD/ListViewTopToolbar'
import { hasPermissionFunction } from 'src/helper/HasPermission'
import { PERMISSION_EXPORT } from 'src/helper/Permission'
import { UserB2ExportButton } from './logic/UserB2ExportButton'

const MyDatagrid = () => {
  const translate = useTranslate()
  const { isFetching, page, filterValues } = useListContext()
  const prevPageRef = useRef()
  const { identity } = useGetIdentity()

  const prevFiltersRef = useRef(filterValues)

  const [pageChanged, setPageChanged] = useState(false)

  useEffect(() => {
    // Comprobar si la página ha cambiado y si isFetching es true
    if (prevPageRef.current !== page && isFetching) {
      prevPageRef.current = page
      setPageChanged(true)
    }
    if (prevFiltersRef.current !== filterValues && isFetching) {
      prevFiltersRef.current = filterValues
      setPageChanged(true)
    } else {
      setPageChanged(false)
    }
  }, [isFetching, page, filterValues])

  return (
    <Datagrid isLoading={pageChanged}>
      <TextField label={translate('ra.field.id')} source='id' />
      <TextField label={translate('ra.field.name')} source='firstname' sortable={false} />
      <TextField label={translate('ra.field.surname')} source='surname' sortable={false} />
      <TextField label={translate('ra.field.username')} source='username' sortable={false} />
      <TextField label={translate('ra.field.mail')} source='mail' sortable={false} />
      <TextField label={translate('ra.field.work_unit')} source='work_unit' sortable={false} />
      <TextField label={translate('ra.field.business_unit')} source='business_unit' sortable={false} />
      {(identity?.is_superadmin || identity?.is_admin) && (
        <BooleanField label={translate('ra.field.is_admin')} source='is_admin' sortable={false} />
      )}
      {identity?.is_superadmin && (
        <BooleanField label={translate('ra.field.is_staff')} source='is_staff' sortable={false} />
      )}
      {identity?.is_superadmin && (
        <BooleanField label={translate('ra.field.is_superadmin')} source='is_superadmin' sortable={false} />
      )}
      <BooleanField label={translate('ra.field.is_active')} source='is_active' sortable={false} />

      <ListViewActionsButtons
        label={translate('ra.action.actions')}
        fieldsName={['short_name']}
        genderElement='femenine'
        disableEdit={false}
        disableDelete={false}
        disableRevision={true}
      />
    </Datagrid>
  )
}

export const UserReservationList = (props) => {
  const translate = useTranslate()
  const notify = useNotify()
  const { identity } = useGetIdentity()

  const allFilters = [
    { source: 'id', name: 'ra.field.id' },
    { source: 'username', name: 'ra.field.username' },
    { source: 'firstname', name: 'ra.field.name' },
    { source: 'surname', name: 'ra.field.surname' },
    { source: 'mail', name: 'ra.field.mail' },
    { source: 'is_active', name: 'ra.field.is_active' },
    identity?.is_superadmin ? { source: 'is_superadmin', name: 'ra.field.is_superadmin' } : undefined,
    { source: 'is_staff', name: 'ra.field.is_staff' },
    { source: 'rol__in', name: 'ra.field.role' },
    { source: 'business_unit_id__in', name: 'ra.field.business_unit' },
    { source: 'work_unit_id__in', name: 'ra.field.work_unit' },
    { source: 'nrf_book', name: 'ra.field.reserve_nrf' },
  ].filter(Boolean);

  

  const onSettled = (data) => {
    if (data.pageInfo) {
      notify(data.pageInfo, { type: 'error' })
    }
  }


  return (
    <>
      <Container className='content'>
        <CardCommon title={translate('ra.entity.user')}>
          <List
            {...props}
            component='div'
            queryOptions={{ onSettled }}
            actions={
              <ListViewTopToolbar
                customFilter
                listFilters={allFilters}
                exporterDisable={true}
                CustomExportButton={
                  hasPermissionFunction('userB2', PERMISSION_EXPORT) ? UserB2ExportButton : null
                }
              />
            }
            sort={{ order: 'DESC', field: 'id' }}
            exporter={false}
          >
            <MyDatagrid />
          </List>
        </CardCommon>
      </Container>
    </>
  )
}
